// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2c8YJ","left":"StickyBox_left__3kE6w","right":"StickyBox_right__1QeLQ"};